import React, { useState } from 'react';
import {
  Form,
  FormItem,
  SubmitButton,
  Button,
  Input,
} from '../../../../../components';

export type EditChunkFormValues = {
  metadata: string;
  text: string;
};

type EditChunkFormProps = {
  onClose: () => void;
  onSave: (data: { metadata: Record<string, any>; document: string }) => void;
  saving: boolean;
  values?: EditChunkFormValues;
};

const EditChunkForm: React.FC<EditChunkFormProps> = ({
  onClose,
  onSave,
  saving,
  values,
}) => {
  const [formValues, setFormValues] = useState<EditChunkFormValues>({
    metadata: values?.metadata || '{}',
    text: values?.text || '',
  });

  const handleSave = () => {
    try {
      const metadata = JSON.parse(formValues.metadata);
      onSave({
        metadata,
        document: formValues.text,
      });
    } catch (error) {
      console.error('Invalid JSON in metadata:', error);
    }
  };

  const isValidJSON = (str: string): boolean => {
    try {
      JSON.parse(str);
      return true;
    } catch {
      return false;
    }
  };

  return (
    <div className="flex flex-col gap-y-12 w-full">
      <Form onChange={setFormValues} initialValue={formValues}>
        <FormItem<EditChunkFormValues>
          required
          name="text"
          label="Text"
          inline={false}
        >
          <Input multiline size="large" placeholder="Enter text content..." />
        </FormItem>
        <FormItem<EditChunkFormValues>
          required
          name="metadata"
          label="Metadata (JSON)"
          inline={false}
          validate={(value: string) => {
            if (!isValidJSON(value)) {
              return 'Please enter valid JSON';
            }
            return '';
          }}
        >
          <Input
            multiline
            size="medium"
            placeholder='{"key": "value"}'
            inputClassName="font-mono text-mainText text-medium"
          />
        </FormItem>

        <div className="flex flex-col gap-y-md justify-center items-center">
          <SubmitButton
            size="medium"
            disabled={saving || !isValidJSON(formValues.metadata)}
            className="w-full"
            label="Save Changes"
            loading={saving}
            onClick={handleSave}
          />
          <Button
            size="medium"
            type="contrast"
            label="Cancel"
            className="w-full text-main"
            onClick={onClose}
          />
        </div>
      </Form>
    </div>
  );
};

export default EditChunkForm;
